import { render, staticRenderFns } from "./EditReward.vue?vue&type=template&id=6b741aa1&"
import script from "./EditReward.vue?vue&type=script&lang=js&"
export * from "./EditReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports